var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrishtinaMall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 136.477,
    height: 52.358,
    viewBox: "0 0 136.477 52.358",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5023",
    "data-name": "Group 5023",
    transform: "translate(17251 366.281)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4446",
    "data-name": "Group 4446",
    transform: "translate(-17251 -366.281)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M47.938,13.091V52.358A31.153,31.153,0,0,1,34.59,48.63V0Z",
    transform: "translate(-18.1 0)",
    fill: "#ec008c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M69.14,13.091V52.358A31.153,31.153,0,0,0,82.488,48.63V0Z",
    transform: "translate(-36.179 0)",
    fill: "#813f8c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M103.7,61.088V27.46h13.348v8.209c0,.477,0,.953-.048,1.43a31.358,31.358,0,0,1-13.3,23.988",
    transform: "translate(-54.264 -14.369)",
    fill: "#44c8f5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M13.348,61.088V27.46H0v8.209c0,.477,0,.953.048,1.43a31.354,31.354,0,0,0,13.3,23.988",
    transform: "translate(0 -14.369)",
    fill: "#faa634",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M52.21,143.405q-1.778-3.18-3.547-6.378h-2.05v8.853h1.726v-6.564l3.675,6.564h1.907v-8.853H52.215v6.378m8.872,2.474h1.707l-3.2-8.853H57.912l-3.161,8.853h1.711l.4-1.125h3.814Zm-2.312-6.469,1.459,4.085H57.316Zm-13.7-2.384H43.319v8.853h1.75Zm-9.115,1.43h2.093v7.423h1.721v-7.423H41.88v-1.43H35.954Zm-3.151,3.857v3.566h1.707v-8.853H32.8v3.566H29.166v-3.566H27.445v8.853h1.721v-3.566Zm-11.565.915H19.517a2.86,2.86,0,0,0,2.6,2.836c1.368.219,3.084-.153,3.718-1.521a2.412,2.412,0,0,0-1.2-3.3c-.834-.453-2.655-.82-3.032-1.583a1.125,1.125,0,0,1,.734-1.607,1.359,1.359,0,0,1,1.85,1.268H25.9a2.813,2.813,0,0,0-.181-.839,2.881,2.881,0,0,0-2.9-1.692,3.661,3.661,0,0,0-2.14.62,2.126,2.126,0,0,0-.906,1.778,2.471,2.471,0,0,0,1.8,2.384,21.426,21.426,0,0,1,2.05.844,1.259,1.259,0,0,1,.629,1.659,1.626,1.626,0,0,1-2.55.281A1.764,1.764,0,0,1,21.243,143.229Zm-3.165-6.2h-1.75v8.853h1.75Zm-6.355,0H8.037v8.853H9.758v-2.57h1.335l1.645,2.57h1.993l-1.778-2.8a2.941,2.941,0,0,0,1.826-2.04,3.118,3.118,0,0,0-3.056-4.019Zm-.281,4.953H9.758v-3.633h1.683a1.8,1.8,0,0,1,1.578,2.5h0a1.669,1.669,0,0,1-1.578,1.135Zm-8.037,0H1.721v-3.633H3.4c2.236,0,2.226,3.633,0,3.633ZM0,137.027v8.853H1.721v-2.57c1.955,0,4.033.267,4.9-1.935h0a3.165,3.165,0,0,0-2.946-4.348Z",
    transform: "translate(-17177.316 -490.219)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M28.041,180.215l-.682,2.293H22.077l5.1-17.758h7.575l5.12,17.758H34.586l-.682-2.293Zm.953-3.442h3.919l-1.926-6.8Zm22.225,1.144v4.591H41V164.75h5.115v13.167Zm11.551,0v4.591H52.52V164.75h5.163v13.167ZM8.552,182.508,5.125,172.049v10.459H0V164.75H6.722l3.766,11.465,3.757-11.465h6.731v17.758H15.832V172.049l-3.437,10.459Z",
    transform: "translate(-17177.316 -504.852)",
    fill: "#231f20"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrishtinaMall);
export default __webpack_public_path__ + "static/media/prishtina-mall.7cfda16f99bb64abe83567431586dbcd.svg";
export { ForwardRef as ReactComponent };